/* Shared, interruptible section navigation with measured header clearance. */
(() => {
  let frame;
  const root = document.documentElement;
  const cancel = () => { cancelAnimationFrame(frame); root.removeAttribute('data-dut-scrolling'); };
  const inset = () => {
    const header = document.querySelector('.section-header');
    if (!header) return 20;
    const style = getComputedStyle(header);
    return 20 + (['sticky', 'fixed'].includes(style.position) ? header.getBoundingClientRect().height : 0);
  };
  window.dutScrollTo = (target, hash) => {
    if (!target) return;
    cancel();
    const top = target === document.body || hash === '#top';
    const review = target.closest('.dut-product-reviews');
    if (review) target = review.querySelector('.dut-product-reviews__inner') || target;
    // Open enclosing disclosures before measuring their content.
    let parent = target.parentElement;
    while (parent) { if (parent.tagName === 'DETAILS') parent.open = true; parent = parent.parentElement; }
    if (target.matches('dut-delivery-estimate')) target.querySelector('details')?.setAttribute('open', '');
    root.setAttribute('data-dut-scrolling', '');
    const start = scrollY;
    const destination = () => Math.max(0, Math.min(top ? 0 : scrollY + target.getBoundingClientRect().top - inset(), document.documentElement.scrollHeight - innerHeight));
    const end = destination();
    const duration = Math.min(2600, 1600 + Math.abs(end - start) * 0.12);
    const began = performance.now();
    const finish = () => {
      window.scrollTo({top: destination(), behavior: 'instant'});
      if (hash && location.hash !== hash) history.pushState(null, '', hash);
      // Focus the page start, not the logo link, after returning to the top.
      // The next Tab still enters the header in normal document order.
      const focus = top ? document.body : target;
      if (focus) {
        if (!focus.hasAttribute('tabindex') && !focus.matches('a,button,input,select,textarea')) {
          focus.setAttribute('tabindex', '-1');
          focus.addEventListener('blur', () => focus.removeAttribute('tabindex'), {once:true});
        }
        focus.focus({preventScroll:true});
      }
      root.removeAttribute('data-dut-scrolling');
      document.dispatchEvent(new Event('dut:scroll-end'));
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
    const step = now => {
      const progress = Math.min((now - began) / duration, 1);
      const eased = (1 - Math.cos(Math.PI * progress)) / 2;
      window.scrollTo({top: start + (destination() - start) * eased, behavior:'instant'});
      if (progress < 1) frame = requestAnimationFrame(step); else finish();
    };
    frame = requestAnimationFrame(step);
  };
  ['wheel','touchstart','pointerdown'].forEach(type => window.addEventListener(type, cancel, {passive:true}));
  window.addEventListener('keydown', event => { if (['Escape','ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key)) cancel(); });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || link.matches('[role="tab"],[data-dhe-tab]')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
    let id; try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) { return; }
    const target = id === 'top' ? document.body : document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    window.dutScrollTo(target, url.hash);
  });
})();
